import React, { useContext, useEffect } from 'react'
import { Outlet } from "react-router-dom";
import Header from '../components/Header/Header';
import Menu from '../components/Menu/Menu';

import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from "@azure/msal-react";
import { loginRequest } from "../environments/environments";
import Login from '../pages/Login/Login';
import useWindowSize from '../hooks/useWindowSize';
import AppDataContext from '../context/AppDataContext';
import RiskHealth from 'pages/RiskHealth/RiskHealth';
import AffectedRegion from 'pages/AffectedRegion/AffectedRegion';
import AddToDashboard from 'pages/RiskHealth/components/AddToDashboard/AddToDashboard';
import GridModal from 'pages/RiskHealth/components/GridModal/GridModal';

export default function Layout() {
  const { instance, accounts } = useMsal();
  const { isUltraWide } = useWindowSize();
  const { isShowModal, navText } = useContext(AppDataContext);
  const {
    setToggleModal,
    isGridModalShow,
    setGridModalShow,
    isAddModalShow,
    setAddModalShow,
  } = useContext(AppDataContext);

  useEffect(() => {
    let isMounted = true;

    // Silent login
    if (localStorage.getItem("isLogout") !== "true") {
      instance
        .handleRedirectPromise()
        .then((tokenResponse: any) => {
          if (!tokenResponse) {
            if (accounts.length === 0) {
              // No user signed in
              instance
                .loginRedirect(loginRequest)
                .then((res) => {
                  console.log(res);
                })
                .catch((e) => {
                  console.log(e);
                });
            }
          }
        })
        .catch((err: any) => {
          console.error(err);
        });
    }

    // cleanup toggles value, if unmounted
    return () => {
      isMounted = false;
    };
  }, []);


  const renderSwitch = () =>{
  switch (navText) {
    case "risk-health":
      return <RiskHealth />;
    case "view-regions":
      return <AffectedRegion />;
  }
}
const closeModal = () => {
  setToggleModal(false);
  setAddModalShow(false);
  setGridModalShow(false);
};


  return (
    <div className={isShowModal ? "showModal app-layout" : "app-layout"}>
      <AuthenticatedTemplate>
        <Menu />

        <div className="page-layout">
          <Header />
          {!isUltraWide && <Outlet />}

          {/* Only For Ultra wide Screens */}
          {isUltraWide && (
            <div className="container-fluid">
              <div className="row  fh">
                <div className="col-2 lhs">
                  <Outlet />
                </div>
                <div className="col-10">
                  {renderSwitch()}

                  {/* isAddModalShow */}
                  {isAddModalShow && <AddToDashboard closeModal={closeModal} />}
                  {isGridModalShow && <GridModal closeModal={closeModal} />}
                </div>
              </div>
            </div>
          )}
        </div>
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <Login />
      </UnauthenticatedTemplate>
    </div>
  );
}
